import React from 'react';
import { Layout } from 'react-admin';
import CrownMenu from './crownMenu/crownMenu';
import CrownAppBar from './crownAppBar/crownAppBar';

const CrownLayout = (props) => <Layout {...props} menu={CrownMenu} appBar={CrownAppBar} />;

export default CrownLayout;
